import React from "react";

import isIntuit from "Intuit/isIntuit";
import { isRenewal } from "QuotePage/urls";
import { connect } from "react-redux";
import AnalyticsTracking from "Utils/AnalyticsTracking";
import { calendlyURL, calendlyRenewalsURL } from "ZeroRuby/urls";

import Header from "Cobalt/Header";
import { ReduxTrigger, Modal, ModalBody, ModalHeader, ModalFooter } from "Cobalt/Modal";
import AgentImg from "Common/Agent/AgentImg";
import BodyText from "Common/BodyText";
import Button from "Common/Button";
import { Div } from "Common/HTML";
import Icon from "Common/Icon";
import { launchSalesforceChat } from "Common/salesforceChatApi";

import { RecommendationSurveyStandaloneTrigger } from "./shared/RecommendationSurveyCard";

import makeBem from "Utils/makeBem";

const bem = makeBem("ContactUsModal");
const ANALYTICS_LOCATION = "compact_quote_page";

function isCalendlyEvent(e) {
  return e.data.event && e.data.event.indexOf("calendly") === 0;
}

class ContactUsModal extends React.Component {
  componentDidMount() {
    window.addEventListener("message", (e) => {
      if (isCalendlyEvent(e)) {
        AnalyticsTracking.trackEvent("cta_clicked", {
          location: ANALYTICS_LOCATION,
          feature: "contact_us_modal",
          type: "calendly_event",
          event: e.data.event,
          is_renewal: isRenewal(),
        });
      }
    });
  }

  handleShow = () => {
    if (this.props.onShow) {
      this.props.onShow();
    }
  };

  handleHide = (reduxTriggerProps) => () => {
    reduxTriggerProps.onHide("contactUsModal");
    if (this.props.onHide) {
      AnalyticsTracking.trackEvent("modal_closed", {
        location: ANALYTICS_LOCATION,
        feature: "contact_us_modal",
      });

      this.props.onHide();
    }
  };

  handleFinishButtonClicked = (reduxTriggerProps) => () => {
    AnalyticsTracking.trackEvent("cta_clicked", {
      location: ANALYTICS_LOCATION,
      feature: "contact_us_modal",
      label: "close",
    });

    this.handleHide(reduxTriggerProps)();
  };

  render() {
    return (
      <ReduxTrigger
        name="contactUsModal"
        modal={(props) => (
          <Modal show={props.show} onShow={this.handleShow} onHide={this.handleHide(props)} className={bem("modal")}>
            <ModalHeader closeButton>
              <Header level={7} mb={0}>
                Contact Us
              </Header>
            </ModalHeader>
            <ModalBody>
              <>
                {isIntuit() ? (
                  <BodyText>Our licensed broker team can help you choose a plan and answer your questions.</BodyText>
                ) : (
                  <>
                    <Div className="flex" mb={4}>
                      <AgentImg size="tiny" />
                      <BodyText ml={4}>
                        If you can answer a few simple questions, I can recommend plans for your business. Otherwise, you can schedule a call with our licensed
                        broker team.
                      </BodyText>
                    </Div>
                    <RecommendationSurveyStandaloneTrigger location="consultation_modal" />
                  </>
                )}

                <Div>
                  <Button
                    color="link"
                    p={0}
                    mt={3}
                    onClick={() => {
                      window.Calendly.initPopupWidget({
                        url: isRenewal() ? calendlyRenewalsURL() : calendlyURL(),
                        prefill: {
                          name: this.props.contactName,
                          email: this.props.companyEmail,
                        },
                      });

                      AnalyticsTracking.trackEvent("cta_clicked", {
                        location: ANALYTICS_LOCATION,
                        feature: "contact_us_modal",
                        type: "calendly_link_clicked",
                        is_renewal: isRenewal(),
                      });
                    }}
                  >
                    <Icon icon="phone" pr={2} flavor="solid" />
                    Book a 30 Minute Consultation
                  </Button>
                </Div>
                <Div>
                  <Button
                    color="link"
                    p={0}
                    mt={3}
                    onClick={() => {
                      launchSalesforceChat();
                      AnalyticsTracking.trackEvent("live_chat_clicked", {
                        location: ANALYTICS_LOCATION,
                        feature: "contact_us_modal",
                      });
                    }}
                  >
                    <Icon icon="comments" pr={2} flavor="solid" />
                    Live Chat with an Agent
                  </Button>
                </Div>
              </>
            </ModalBody>
            <ModalFooter>
              <Button onClick={() => this.handleFinishButtonClicked(props)()}>Return to Quote</Button>
            </ModalFooter>
          </Modal>
        )}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  contactName: state.companyProfile.contactName,
  companyEmail: state.companyProfile.email,
});

const withRedux = connect(mapStateToProps);

export default withRedux(ContactUsModal);
